import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getViewInitialState } from 'src/store/view/reducer';
import { initAppAction } from '../../../../store/view/actions';
import { confirmClientAction } from '../../../../store/client/actions';
import {
  initPaymentAction,
  initPaymentFailAction,
  payUnitellerAction,
  payUnitellerFailAction,
  pay3dsAction,
  pay3dsFailAction,
  show3dsPopupAction,
  orderPaidSuccessAction,
} from '../../../../store/payment/reducer';
import {
  createCertificateAction,
  createCertificateSuccessAction,
  downloadCertificateAction,
  downloadCertificateSuccessAction,
} from '../certificate/sagaActions';
import type { ViewGiftPageProps } from '../../types';

export interface ViewState {
  isWhitelabel: boolean;
  isMobile: boolean;
  isTyping: boolean;
  isClientConfirmed: boolean;
  isProcessing: boolean;
  isErrorShown: boolean;
  is3dsShown: boolean;
  isWidgetShown: boolean;
  error: null | { message: string };
  app: null | string;
  platform: null | string;
  cashbackIcon: typeof window.customCashback | undefined;
}

const initialState = {
  isMobile: false,
  isTyping: false,
  isClientConfirmed: false,
  isProcessing: false,
  isErrorShown: false,
  is3dsShown: false,
  isWidgetShown: true,
  error: null,
  platform: null,
  ...getViewInitialState(),
  isWhitelabel: false, // certificates allowed only on main site
} as ViewState;

const certificateSlice = createSlice({
  name: 'view',
  initialState,
  reducers: {
    showErrorPopup(state) {
      state.isErrorShown = true;
      state.isProcessing = false;
    },
    hideErrorPopup(state) {
      state.isErrorShown = false;
    },
    stopTyping(state) {
      state.isTyping = true;
    },
    startTyping(state) {
      state.isTyping = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initAppAction, (state, { payload: { appName, ...rest } }) => {
        const { isMobile, platform } = rest as ViewGiftPageProps;
        return {
          ...state,
          app: appName,
          isMobile,
          platform,
        };
      })
      .addCase(confirmClientAction, (state, action) => {
        state.isClientConfirmed = !!action.payload;
      })
      .addMatcher(
        isAnyOf(
          initPaymentAction,
          payUnitellerAction,
          pay3dsAction,
          createCertificateAction,
          downloadCertificateAction,
        ),
        (state) => {
          state.isProcessing = true;
        },
      )
      .addMatcher(
        isAnyOf(
          show3dsPopupAction,
          orderPaidSuccessAction,
          createCertificateSuccessAction,
          downloadCertificateSuccessAction,
        ),
        (state) => {
          Object.assign(state, {
            isProcessing: false,
            error: null,
          });
        },
      )
      .addMatcher(
        isAnyOf(
          initPaymentFailAction,
          payUnitellerFailAction,
          pay3dsFailAction,
          downloadCertificateAction,
        ),
        (state, action) => {
          Object.assign(state, {
            isProcessing: false,
            error: action.payload,
          });
        },
      );
  },
});

export const { showErrorPopup, hideErrorPopup, stopTyping, startTyping } =
  certificateSlice.actions;
export const { name } = certificateSlice;
export default certificateSlice.reducer;
